import React from "react";
const SvgBBiconsPin = props => (
    <svg viewBox="0 0 200 200" {...props}>
        {props.title && <title>{props.title}</title>}
        <g id="Obecné_ikony" data-name="Obecné ikony">
            <g id="Pin">
                <path d="M31,168.45l46.19-56a3.4,3.4,0,0,1,5.13-.25l5.41,5.4a3.41,3.41,0,0,1-.25,5.14L31.55,169C29.93,170.31,29.7,170.08,31,168.45Z"/>
                <path d="M134.73,31a2.84,2.84,0,0,0-4,0,27,27,0,0,0-8,19.13L101.89,71A41.6,41.6,0,0,0,63,82.44v0a2.84,2.84,0,0,0,0,4L113.53,137a2.85,2.85,0,0,0,4,0A41.56,41.56,0,0,0,129,98.12L149.9,77.24A27,27,0,0,0,169,69.31l0,0a2.84,2.84,0,0,0,0-4Z"/>
            </g>
        </g>
    </svg>
);

export default SvgBBiconsPin;
